import dynamic from "next/dynamic";
import VerticalTabsConfig from "./vertical-tabs-config";
import VerticalTabsAdvancedConfig from "./vertical-tabs-advanced-config";
const VerticalTabsComponent = dynamic(()=>import("./vertical-tabs-component"));
export default {
    VerticalTabsComponent,
    VerticalTabsConfig,
    VerticalTabsAdvancedConfig
};
